// Loaders
import { BaseLogicModuleLoader } from "../../base/loaders/BaseLogicModuleLoader";
/**
 * Loader class for loading logic modules in the Teams app
 */
export class MetaOSAppLogicModuleLoader extends BaseLogicModuleLoader {
}
